import React from "react";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ExportOperation = ({ operationTableData }) => {
    // Export to Excel
    const exportToExcel = async () => {

        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Zone");

        // Define styles
        const boldFont = { bold: true };

        // Get current date and time
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Operation Details Generated on: ${formattedDate}, ${formattedTime}`;

        // Add the downloadDateTime to the worksheet
        worksheet.addRow(["", "", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 3);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        // Add "Operation Details" header
        worksheet.addRow(["", "", "Operation Details", ""]);
        worksheet.mergeCells(2, 2, 2, 3);
        worksheet.getCell(2, 2).value = "Operation Details";
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        // Define table headers
        const tableHeaderRow = worksheet.addRow([
            "S.No", "Operation", "Status"
        ]);
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
            if (colNumber >= 1 && colNumber <= 4) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" }, // Background color
                    bgColor: { argb: "FFFFFFFF" } // Text color
                };
            }
        });

        // Add data rows
        operationTableData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.operationName || "N/A",
                item.isActive ? "Active" : "InActive"
            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.alignment = { horizontal: "center" };
            });
        });

        // Set column widths dynamically based on content
        worksheet.columns = [
            { width: 5 },
            { width: 25 },
            { width: 25 },
        ];

        // Save the workbook to a file
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Operations.xlsx";
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Operation Report Generated on: ${formattedDate} ${formattedTime}`;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Operation Details", 14, 20);
        doc.setFontSize(12);
        doc.text(downloadDateTime, 14, 30);

        const tableColumn = ["S.No", "Operation", "Status"];
        const tableRows = operationTableData.map((row, index) => [
            index + 1,
            row.operationName || "N/A",
            row.isActive ? "Active" : "InActive"
        ]);

        const tableOptions = {
            startY: 40,
            head: [tableColumn],
            body: tableRows,
            headStyles: {
                fillColor: [246, 177, 177],
                textColor: [0, 0, 0],
                fontSize: 12,
                halign: 'center',
            },
            bodyStyles: {
                fontSize: 10,
                halign: 'center',
            },
        };
        autoTable(doc, tableOptions);
        doc.save("Operations.pdf");
    };

    return (
        <>
            <button className="btn btn-excel" onClick={exportToExcel}>
                <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                Excel
            </button>
            <button className="btn btn-excel" onClick={exportToPDF}>
                <i className="fa-regular fa-file-pdf me-1 icon-container"></i>
                PDF
            </button>
        </>
    );
};

export default ExportOperation;
